import React from "react";
import { SovosPill } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const isActiveValue = (active) => active === true || active === 1 || active === "1" || active === 3;

const ActiveStatus = (props) => {
    const { i18n } = useGlobalValue();
    const { value: cell } = props || {};
    const isActive = isActiveValue(cell?.active);
    const labelKey = isActive ? "is-active-1" : "is-active-0";

    return <SovosPill color={isActive ? "success" : "neutral"}>{i18n`${labelKey}`}</SovosPill>;
};

export default ActiveStatus;
